import React from "react";
import BlocksHeader from "./blocksHeader";
import CanvasHeader from "./canvasHeader";

import "./header.styles.css";

const CanvasHeaderWrapper = ({ onHandleBlockRender, handleStop }) => {
  return (
    <div className="canvasheader__wrapper">
      <CanvasHeader />
      <BlocksHeader
        onHandleBlockRender={onHandleBlockRender}
        handleStop={handleStop}
      />
    </div>
  );
};

export default CanvasHeaderWrapper;
